import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import './navbar.css';

export const PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.sofajoa.ctcae6cloud&pcampaignid=web_share';

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileMenuOpen: false,
            appBannerVisible: true
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname && this.state.mobileMenuOpen) {
            this.setState({ mobileMenuOpen: false });
        }
    }

    toggleMobileMenu = () => {
        this.setState(prevState => ({
            mobileMenuOpen: !prevState.mobileMenuOpen
        }));
    };

    closeMobileMenu = () => {
        this.setState({ mobileMenuOpen: false });
    };

    dismissAppBanner = () => {
        this.setState({ appBannerVisible: false });
    };

    getMobileTitle() {
        const path = this.props.location.pathname;
        if (path.startsWith('/ctcae5')) {
            return 'CTCAE v5';
        }
        if (path.startsWith('/ctcae6')) {
            return 'CTCAE v6';
        }
        return 'CTCAE CLOUD';
    }

    render() {
        const path = this.props.location.pathname;
        const isCtcae5 = path.startsWith('/ctcae5');
        const isCtcae6 = path.startsWith('/ctcae6');

        const downloadView = (
            <div className="download hidden-xs">
                <a href={PLAY_STORE_URL} target='_blank' rel="noopener noreferrer">
                    <img alt='Get it on Google Play' width="100%" src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'/>
                </a>
            </div>
        );

        return (
            <div className="title-container">
                {this.state.appBannerVisible && (
                    <div className="app-banner" role="status">
                        <div className="container-fluid app-banner-inner">
                            <p className="app-banner-text">
                                <strong>CTCAE v6 Cloud</strong> is now on Google Play —
                                <span className="hidden-xs"> get the app from the top right.</span>
                                <a
                                    className="app-banner-link visible-xs-inline"
                                    href={PLAY_STORE_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    download free
                                </a>
                            </p>
                            <button
                                type="button"
                                className="app-banner-close"
                                aria-label="Dismiss announcement"
                                onClick={this.dismissAppBanner}
                            >
                                ×
                            </button>
                        </div>
                    </div>
                )}
                <div className="container-fluid">
                    <div className="main">
                        <div className="row">
                            <div className="col-sm-3 hidden-xs">
                                <div className="title">
                                    <Link to="/ctcae6" aria-label="CTCAE Cloud home">
                                        <img width='100' height='30' src={ require('../../assets/images/CC_title.png') } alt="CTCAE Cloud" />
                                    </Link>
                                </div>
                            </div>
                            <div className="visible-xs col-xs-12">
                                <div className="mobile-header">
                                    <button
                                        type="button"
                                        className="mobile-menu-icon"
                                        aria-label={this.state.mobileMenuOpen ? 'Close menu' : 'Open menu'}
                                        aria-expanded={this.state.mobileMenuOpen}
                                        aria-controls="mobile-primary-nav"
                                        onClick={this.toggleMobileMenu}
                                    >
                                        <i className={`fa fa-2x ${this.state.mobileMenuOpen ? 'fa-times' : 'fa-bars'}`} aria-hidden="true"/>
                                    </button>
                                    <div className="title">{this.getMobileTitle()}</div>
                                </div>
                                {this.state.mobileMenuOpen && (
                                    <nav id="mobile-primary-nav" className="mobile-menu" aria-label="Primary">
                                        <Link
                                            to='/ctcae6'
                                            className={`mobile-menu-item${isCtcae6 ? ' active' : ''}`}
                                            onClick={this.closeMobileMenu}
                                            aria-current={isCtcae6 ? 'page' : undefined}
                                        >
                                            CTCAE v6
                                        </Link>
                                        <Link
                                            to='/ctcae5'
                                            className={`mobile-menu-item${isCtcae5 ? ' active' : ''}`}
                                            onClick={this.closeMobileMenu}
                                            aria-current={isCtcae5 ? 'page' : undefined}
                                        >
                                            CTCAE v5
                                        </Link>
                                        <a
                                            className="mobile-menu-item"
                                            href={PLAY_STORE_URL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={this.closeMobileMenu}
                                        >
                                            Get the app
                                        </a>
                                    </nav>
                                )}
                            </div>
                            <div className="col-sm-2 hidden-xs">
                                <nav className="menu" aria-label="Primary">
                                    <div className="list-item">
                                        <Link to='/ctcae6' aria-current={isCtcae6 ? 'page' : undefined}>CTCAE v6</Link>
                                    </div>
                                </nav>
                            </div>
                            <div className="col-sm-2 hidden-xs">
                                <nav className="menu" aria-label="CTCAE versions">
                                    <div className="list-item">
                                        <Link to='/ctcae5' aria-current={isCtcae5 ? 'page' : undefined}>CTCAE v5</Link>
                                    </div>
                                </nav>
                            </div>
                            <div className="col-sm-5 hidden-xs">
                                <div className="pull-right menu">{downloadView}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/component/navbar/navbar.js